import { render, staticRenderFns } from "./HeadNav.vue?vue&type=template&id=1489fa23&"
import script from "./HeadNav.vue?vue&type=script&lang=js&"
export * from "./HeadNav.vue?vue&type=script&lang=js&"
import style0 from "./HeadNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports